<template>
    <LoadingCard v-if="loading && !hasLoaded"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Chemical Active Ingredients</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new chemical Active Ingredient"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Chemical Active Ingredients
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>

            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page" :busy="loading > 0"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="contamination_period" slot-scope="data">
                    <template v-if="data.item.contamination_period">
                        {{ data.item.contamination_period | number_format }} days
                    </template>
                    <span class="text-muted" v-else>(none)</span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Chemical Active Ingredient'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" @refresh="refetch" :active-ingredient="editingIngredient" v-model="editingIngredient" v-if="editingIngredient" />
    </div>
</template>

<script>
import listChemicalActiveIngredientsQuery from '@views/ChemicalActiveIngredients/Browse/queryListChemicalActiveIngredients.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseChemicalActiveIngredients',
  apollo: {
    activeIngredients: {
      query: listChemicalActiveIngredientsQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.activeIngredients = data.filterChemicalActiveIngredients.data;
          this.pagination.total = data.filterChemicalActiveIngredients.meta.total;
        }
      },
    },
  },
  watch: {
    loading(newValue) {
      if (!this.hasLoaded && newValue === 0) {
        this.hasLoaded = true;
      }
    },
  },
  data() {
    return {
      activeIngredients: [],
      editingIngredient: null,
      creating: false,
      loading: 0,
      hasLoaded: false,
      pagination: {
        page: 1,
        total: 0,
        limit: this.$tableDefaultPageSize,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Chemical Active Ingredient',
            sortable: true,
          },
          {
            key: 'contamination_period',
            label: 'Restricted Entry Interval',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      console.log('refreshing table data');
      return (this.activeIngredients || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(activeIngredient) {
      this.editingIngredient = activeIngredient;
    },
    closeEditDialog() {
      this.editingIngredient = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
    refetch() {
      this.$apollo.queries.activeIngredients.refetch();
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
